module.exports = __webpack_public_path__ + "img/poker.e171bfe3.png";